// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove loader if it's still showing
const loader = document.getElementById('initial-loader');
if (loader) {
  loader.style.display = 'none';
}